import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 140,
    damping: 28,
    restDelta: 0.001,
  });

  return (
    <div className="fixed top-0 left-0 right-0 z-[1000] h-[3px] pointer-events-none">
      <motion.div
        style={{ scaleX, transformOrigin: "0% 50%" }}
        className="h-full w-full bg-gradient-to-r from-[#E97818] via-[#F29A0C] to-[#FFD166] shadow-[0_0_18px_rgba(242,154,12,0.55)]"
      />
    </div>
  );
};

export default ScrollProgress;
